import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import EthereumIcon from '@/assets/icons/ethereum.svg?react';
import PixIcon from '@/assets/icons/pix.svg?react';
import PolygonIcon from '@/assets/icons/polygon.svg?react';
import SPEIIcon from '@/assets/icons/spei.svg?react';
import TronIcon from '@/assets/icons/tron.svg?react';
import EmptyIcon from '@/assets/icons/unset.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { FundingMethodItem, PaymentRailType } from '@/types/currency';

interface Props {
  readonly fundingMethod: FundingMethodItem;
}

interface LabelAndIcon {
  readonly label: string;
  readonly Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const FundingMethodMenuItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { fundingMethod } = props;

  const tr = useTranslator();

  const ResolvedMethod = React.useMemo((): LabelAndIcon => {
    switch (fundingMethod.method) {
      case PaymentRailType.PIX:
        return {
          label: tr('BRAZILIAN_PIX'),
          Icon: PixIcon,
        };
      case PaymentRailType.SPEI:
        return {
          label: tr('MEXICAN_SPEI'),
          Icon: SPEIIcon,
        };
      case PaymentRailType.Polygon:
        return {
          label: 'USDC (Polygon)',
          Icon: PolygonIcon,
        };
      case PaymentRailType.Ethereum:
        return {
          label: `${fundingMethod.currency} (Ethereum)`,
          Icon: EthereumIcon,
        };
      case PaymentRailType.TRON:
        return {
          label: `${fundingMethod.currency} (Tron)`,
          Icon: TronIcon,
        };
      default:
        return {
          label: 'Unknown',
          Icon: EmptyIcon,
        };
    }
  }, [fundingMethod, tr]);

  return (
    <Box display="flex" alignItems="center" gap={1} py="2px">
      <ResolvedMethod.Icon height={16} width={16} />
      <Typography>{ResolvedMethod.label}</Typography>
    </Box>
  );
};
